<template>
  <div class="multiple-box">
    <div
      v-for="item in options"
      :key="item.choiceKey"
      class="sy-mutiple-choices-item"
      :title="item.value"
    >
      <el-checkbox
        :key="item.choiceKey"
        :disabled="disabled || item.state === 1"
        v-on="$listeners"
        v-bind="{ ...$props }"
        :label="item.choiceKey"
      >{{ item.value }}
      </el-checkbox
      >
    </div>
  </div>
</template>

<script>
  import {multipleChoicesProps} from '../index.js'

  export default {
    name: 'vertical-radio-multiple-choices',
    props: multipleChoicesProps,
    methods: {
      selectChange () {
        this.$emit('validateField')
      }
    }
  }
</script>

<style lang="scss" scoped></style>
